export const DEFECTS = {
  ROOT: '/defects',
  APARTMENTS: '/defects/apartments',
  ENG_NETWORKS: '/defects/engineering_networks',
};
